import * as v from "valibot";

export const searchParams = v.object({
  tab: v.optional(v.string()),
});
